import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Link, Redirect, Route, Switch } from "react-router-dom";
import "../../assets/css/styles.css";
import AjaxHandler from "../../commons/ajax/AjaxHandler.js";
import Config from "../../commons/config/Config.js";
import ConfigBusiness from "../../commons/config/ConfigBusiness.js";
import appHistory from "../../commons/history.js";
import Security from "../../commons/security/Security.js";
import NotificationBell from "../../components/notificaciones/NotificationBell.js";
import ChangePassword from "../../components/auth/ChangePassword.js";
import Avl from "../../components/avl/Avl.js";
import Videos from "../../components/ayuda/Videos.js";
import Bases from "../../components/bases/Bases.js";
import Rutas from "../../components/rutas/Rutas.js";
import Calendarios from "../../components/calendarios/Calendarios.jsx";
import Categorias from "../../components/categorias/Categorias.js";
import CentrosBeneficios from "../../components/centrosbeneficios/CentrosBeneficios.js";
import CentrosCostos from "../../components/centroscostos/CentrosCostos.js";
import Clases from "../../components/clases/Clases";
import Combustibles from "../../components/combustibles/Combustibles.js";
import CombustiblesLogGrid from "../../components/combustibles/CombustiblesLogGrid.js";
import OTs from "../../components/ordenestrabajo/OTs.js";
import KmMovil from "../../components/reportes/KmMovil.js";
import MovilesInmovilizados from "../../components/reportes/movilesImovilizados/MovilesInmovilizados.jsx";
import Infracciones from "../../components/infracciones/Infracciones.js";
import Panol from "../../components/panol/Panol.js";
import Panol2 from "../../components/panol2/Panol2.jsx";
import Repuestos from "../../components/repuestos/Repuestos.jsx";
import Correctivos from "../../components/correctivos/Correctivos.js";
import DashboardEconomico from "../../components/dashboards/DashboardEconomico.js";
import DashboardOperativo from "../../components/dashboards/DashboardOperativo.js";
import DashboardAnalitico from "../../components/dashboards/operativo2/DashboardAnalitico.js";
import DashboardOperativo2 from "../../components/dashboards/operativo2/DashboardOperativo2.js";
import Equipamiento from "../../components/equipamiento/Equipamiento.js";
import TipoEquipamiento from "../../components/equipamiento/TipoEquipamiento.js";
import Error from "../../components/errors/Error.js";
import Facturas from "../../components/facturas/Facturas.js";
import Formulario from "../../components/formularios/Formulario.js";
import TipoFormulario from "../../components/formularios/TipoFormulario.js";
import FormularioRecurrencia from "../formularios/FormularioRecurrencia.js";
import SafeFeedbackReportes from "../../components/safeFeedback/Reportes.js";
import SafeFeedbackTipoFormulario from "../safeFeedback/SafeFeedbackTipoFormulario.jsx";
import SafeFeedbackFormulario from "../safeFeedback/SafeFeedbackFormulario.jsx";
import SafeFeedbackRanking from "../safeFeedback/SafeFeedbackRanking.jsx";
import SafeFeedbackQR from "../../components/safeFeedback/QR.js";
import GastoExtra from "../../components/gastoextra/GastoExtra";
import TipoGastoExtra from "../../components/gastoextra/TipoGastoExtra";
import Gerenciadores from "../../components/gerenciadores/Gerenciadores.js";
import GPSDevices from "../../components/gps_devices/GPSDevices.js";
import LlantaAsignaciones from "../../components/llantas/LlantaAsignaciones.js";
import LlantaInspecciones from "../../components/llantas/LlantaInspecciones.js";
import LlantaMarcas from "../../components/llantas/LlantaMarcas.js";
import Llantas from "../../components/llantas/Llantas.js";
import LlantasModelos from "../../components/llantas/LlantasModelos.js";
import Marcas from "../../components/marcas/Marcas.js";
import Modelos from "../../components/modelos/Modelos.js";
import ModeloTipos from "../../components/modelotipos/ModeloTipos.js";
import Motivos from "../../components/motivos/Motivos.js";
import Moviles from "../../components/moviles/Moviles.js";
import PoliticasPrivacidad from "../../components/politicasPrivacidad/PoliticasPrivacidad.js";
import PoliticaPrivacidadModal from "../../components/politicasPrivacidad/PoliticaPrivacidadModal.jsx";
import Osticket from "../../components/osticket/Osticket.js";
import Perfiles from "../../components/perfiles/Perfiles.js";
import Personas from "../../components/personas/Personas.js";
import PlanMantenimientoPreventivos from "../../components/planmantenimientopreventivos/PlanMantenimientoPreventivos.js";
import Preventivos from "../../components/preventivos/Preventivos.js";
import Regiones from "../../components/regiones/Regiones.js";
import ActualizacionKm from "../../components/reportes/ActualizacionKm.js";
import NoReportan from "../../components/reportes/NoReportan.js";
import Rop from "../../components/rop/Rop.js";
import Servicios from "../../components/servicios/Servicios.js";
import SubRegiones from "../../components/subregiones/Subregiones.js";
import Talleres from "../../components/talleres/Talleres.js";
import Tareas from "../../components/tareas/Tareas.js";
import Tickets from "../../components/tickets/Tickets.js";
import TicketsGestoria from "../../components/ticketsgestoria/TicketsGestoria.js";
import UsuariosMoviles from "../../components/usuariosmoviles/UsuariosMoviles.js";
import Vencimientos from "../../components/vencimientos/Vencimientos.js";
import Bienvenido from "../bienvenido/Bienvenido.js";
import Divisiones from "../divisiones/Divisiones.js";
import LlantaOdometroGrid from "../llantas/LlantaOdometroGrid";
import BISuite from "../biSuite/BiSuite.jsx";
import AssetControl from "../assetControl/AssetControl.jsx";
import InsumosMarcas from "../insumosMarcas/InsumosMarcas.jsx";
import ItemClasificaciones from "../itemClasificaciones/ItemClasificaciones.jsx";
import ItemCategoria from "../itemCategoria/ItemCategoria.jsx";
import Notificacion from '../app/Notificacion.js';
import CompaniasOrigen from '../companiasOrigen/CompaniasOrigen.js';
import Disponibilidad from "../disponibilidad/Disponibilidad.jsx";
import ConfigPeriodosPresupuestarios from "../configPeriodosPresupuestarios/ConfigPeriodosPresupuestarios.jsx";
import PeriodoPresupuestario from "../periodoPresupuestario/PeriodoPresupuestario.jsx";
import { PERMISSION_PATH } from "../../commons/constants/biSuitePermissionPath.js";
import { ASSET_CONTROL_PERMISSION_PATH } from "../../commons/constants/assetControlPermissionPath.js";
import Transportadoras from "../../components/transportadoras/Transportadoras.js";
import SedeExterna from "../sedeExterna/SedeExterna.js";
import PowerBIReport from "../biSuite/PowerBIReport.js";
import MovilesRutasImportFilesGrid from "../disponibilidad/MovilesRutasImportFilesGrid.js";
import IntercomBoot from '../../commons/intercom/IntercomBoot.js';
import DisponibilidadReglas from "../disponibilidad/reglas/DisponibilidadReglas.js";
import BipeosGrid from "../disponibilidad/bipeos/BipeosGrid.jsx";
import Intercom from '@intercom/messenger-js-sdk';
import FirebaseMessagingListener from '../../commons/firebase/FirebaseMessagingListener.js';
import SwaggerDocs from '../swaggerDocs/SwaggerDocs.js';
import Monolog from '../monolog/Monolog.js';
import EricContainer from '../eric/EricContainer.js';
import Eric from '../eric/Eric.js';
import EricHeaderSearch from '../eric/EricHeaderSearch.js';

const NotFound = () => (
  <div
    style={{
      width: "100%",
      height: "100%",
      position: "absolute",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <div>
      <h1 style={{ fontSize: "6rem" }}>
        404 -{" "}
        <FormattedMessage
          id="layout.not_found.pagina_no_encontrada"
          defaultMessage="Página No Encontrada!"
        />
      </h1>
      <Link to="/" style={{ fontSize: "3rem" }}>
        {" "}
        <FormattedMessage
          id="layout.not_found.ir_a_inicio"
          defaultMessage="Ir a Inicio"
        />
      </Link>
    </div>
  </div>
);

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      avatar: null,
      codigo: 0,
      showPlayStoreButton: false,
      showLogout: false,
      loadingLogoMenuLateral: true,
      logoMenuLateralUrl: null,
      biParameters:[],
      showBImenu: false,
      showACmenu: false,
      politicaPendiente: null,
    };
    this.ajaxHandler = new AjaxHandler();
  }

  // --- DEVOPS FIX: ARQUITECTURA DE MARCA BLANCA (CARPETAS) ---
  getBrandedLogo(defaultFilename, visibilityConfigKey = null) {
      if (visibilityConfigKey) {
          const isVisible = ConfigBusiness.get(visibilityConfigKey);
          if (isVisible === "false") return null;
      }
      const clientSlug = ConfigBusiness.get("generales.clienteSlug");
      if (clientSlug && clientSlug !== "false" && clientSlug !== "default") {
          return `${process.env.PUBLIC_URL}/images/branding/${clientSlug}/${defaultFilename}`;
      }
      return `${process.env.PUBLIC_URL}/images/company/${defaultFilename}`;
  }

  actualizarMenuActivo(path) {
    const targetPath = (typeof path === 'string' ? path : null) || window.location.pathname;
    const nav = document.getElementById('main-menu-navigation');
    if (!nav) return;

    nav.querySelectorAll('li.active').forEach(function(li) { li.classList.remove('active'); });
    nav.querySelectorAll('li.menu-vec-activo').forEach(function(li) { li.classList.remove('menu-vec-activo'); });

    var targetParentLi = null;
    var bestLink = null;
    var bestLength = -1;
    nav.querySelectorAll('a[href]').forEach(function(link) {
      const href = link.getAttribute('href');
      if (!href || href === '#' || href.charAt(0) !== '/') return;
      const matches = href === targetPath || targetPath === href + '/' || targetPath.indexOf(href + '/') === 0;
      if (matches && href.length > bestLength) {
        bestLink = link;
        bestLength = href.length;
      }
    });
    if (bestLink) {
      const li = bestLink.closest('li');
      if (li) {
        li.classList.add('active');
        const parentLi = li.parentElement && li.parentElement.closest('li');
        if (parentLi) {
          parentLi.classList.add('menu-vec-activo');
          parentLi.classList.add('open');
          targetParentLi = parentLi;
        }
      }
    }

    // Cerrar acordeones que no corresponden al ítem activo actual
    nav.querySelectorAll('li.open').forEach(function(li) {
      if (li !== targetParentLi) {
        li.classList.remove('open');
      }
    });
  }

  componentDidMount() {
    this.loadGoogleMaps();
    this.loadStatics();
    this.onPopstate = function() { this.actualizarMenuActivo(); }.bind(this);
    window.addEventListener('popstate', this.onPopstate);
    this._lastPathname = window.location.pathname;
    this.unlistenHistory = appHistory.listen(function(update) {
      var pathname = update && update.location ? update.location.pathname : window.location.pathname;
      setTimeout(function() { this.actualizarMenuActivo(pathname); }.bind(this), 50);
      var prevRoot = this._lastPathname.split('/')[1];
      var nextRoot = pathname.split('/')[1];
      if (prevRoot !== nextRoot) {
        var contentEl = document.querySelector('.app-content.content');
        if (contentEl) { contentEl.scrollTop = 0; }
        window.scrollTo(0, 0);
      }
      this._lastPathname = pathname;
    }.bind(this));
    setTimeout(this.actualizarMenuActivo.bind(this), 500);
    this.loadAvatar();
    this.checkBIoptions();
    this.checkACoptions();
    this.setState({
      showLogout: ConfigBusiness.get("frontend.showLogout") === "true",
    });

    FirebaseMessagingListener.init();
    this.ajaxHandler.subscribe(this);

    if (ConfigBusiness.get('politicaDePrivacidad.usaInterna') === 'true') {
      this.ajaxHandler.getJson('/politicas-privacidad/pendiente').then((data) => {
        if (data && data.pendiente) {
          this.setState({ politicaPendiente: data });
        }
      }).catch(() => {});
    }

    this.ajaxHandler.getJson("/clienteurl/getGooglePlayCode").then((data) => {
      if (data)
        this.setState({
          ...this.state,
          codigo: data,
          showPlayStoreButton: true,
        });
    });

    fetch(Config.get('apiUrlBase') + '/public/contextos_imagenes/logoMenuLateral', {
      method: 'GET',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
      },
    }).then(response => {
        let contentType = response.headers.get('Content-Type');
        if (contentType && contentType.startsWith('image/')) {
            return response.blob();
        } else {
            throw new Error('La respuesta no es una imagen');
        }
    }).then(blob => {
        let fileUrl = URL.createObjectURL(blob);
        this.setState({ logoMenuLateralUrl: fileUrl });
    }).catch((error) => {
    }).finally(() => {
        this.setState({ loadingLogoMenuLateral: false });
    });

    IntercomBoot.boot();
  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
    if (this.onPopstate) {
      window.removeEventListener('popstate', this.onPopstate);
      this.onPopstate = null;
    }
    if (this.unlistenHistory) {
      this.unlistenHistory();
      this.unlistenHistory = null;
    }
  }

  loadAvatar() {
    let persona = JSON.parse(localStorage.getItem("persona"));
    let avatar = {
      className: "user-avatar",
      backgroundImage: null,
      initials:
        persona.nombre.substr(0, 1).toUpperCase() +
        persona.apellido.substr(0, 1).toUpperCase(),
    };
    if (persona && persona.foto) {
      let photoUrl =
        Config.get("apiUrlBase") + "/personas/foto/" + persona.foto;
      fetch(photoUrl, {
        method: "GET",
        headers: {
          "Authorization-Token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.status === 200) {
            return response.blob();
          }
        })
        .then((imgBlob) => {
          if (imgBlob) {
            avatar.className = "user-avatar-image";
            avatar.backgroundImage = URL.createObjectURL(imgBlob);
            avatar.initials = null;
          }
        })
        .catch(() => {
          avatar.className = "user-avatar";
        })
        .finally(() => {
          this.setState({
            avatar: avatar,
          });
        });
    } else {
      avatar.className = "user-avatar";
      this.setState({
        avatar: avatar,
      });
    }
  }

  loadStatics() {
    document.body.className =
      "vertical-layout vertical-menu 2-columns menu-collapsed fixed-navbar";
    document.body.setAttribute("data-col", "2-columns");

    const appMenuScript = document.createElement("script");
    appMenuScript.src =
      process.env.PUBLIC_URL + "/ui-template/app-assets/js/core/app-menu.js";
    appMenuScript.async = true;
    document.body.appendChild(appMenuScript);
    appMenuScript.onload = () => {
      const appScript = document.createElement("script");
      appScript.src =
        process.env.PUBLIC_URL + "/ui-template/app-assets/js/core/app.js";
      appScript.async = true;
      document.body.appendChild(appScript);
      appScript.onload = () => {
        const customizerScript = document.createElement("script");
        customizerScript.src =
          process.env.PUBLIC_URL +
          "/ui-template/app-assets/js/scripts/customizer.js";
        customizerScript.async = true;
        document.body.appendChild(customizerScript);
      };
    };
  }

  loadGoogleMaps() {
    const apiGoogleScript = document.createElement("script");
    apiGoogleScript.src =
      "https://maps.googleapis.com/maps/api/js?key=" +
      ConfigBusiness.get("frontend.googleMapsKey") +
      "&libraries=places";
    apiGoogleScript.async = true;
    apiGoogleScript.defer = true;
    apiGoogleScript.id = "google-maps-include";
    document.head.prepend(apiGoogleScript);
  }

  checkBIoptions() {
    const biParameters =[];
    for (let i = 1; i <= PERMISSION_PATH.length; i++) {
      const url = (ConfigBusiness.get(`menu.BISuite.submenuBI_${i}.url`)) || '';
      const habilitado = (ConfigBusiness.get(`menu.BISuite.submenuBI_${i}.habilitado`)) || '';
      let nombre = (ConfigBusiness.get(`menu.BISuite.submenuBI_${i}.nombre`)) || '';
      nombre = nombre.length > 23 ? nombre.slice(0, 23) : nombre;
      const permission = Security.hasPermission(`BI_SUITE_${i}`);
      const bi = { url, habilitado, nombre, permission };
      biParameters.push(bi);
    }
    const showBImenu = biParameters.some( bi => {
      return bi.url != '' && bi.nombre != '' && bi.habilitado === 'true' && bi.permission
    });
    this.setState({
      biParameters,
      showBImenu
    });
  }

  checkACoptions() {
    const acParameters =[];
    for (let i = 1; i <= ASSET_CONTROL_PERMISSION_PATH.length; i++) {
      const url = (ConfigBusiness.get(`menu.AssetControl.submenuAC_${i}.url`)) || '';
      const habilitado = (ConfigBusiness.get(`menu.AssetControl.submenuAC_${i}.habilitado`)) || '';
      let nombre = (ConfigBusiness.get(`menu.AssetControl.submenuAC_${i}.nombre`)) || '';
      nombre = nombre.length > 23 ? nombre.slice(0, 23) : nombre;
      const permission = Security.hasPermission(`ASSET_CONTROL_${i}`);
      const ac = { url, habilitado, nombre, permission };
      acParameters.push(ac);
    }
    const showACmenu = acParameters.some( ac => {
      return ac.url != '' && ac.nombre != '' && ac.habilitado === 'true' && ac.permission
    });
    this.setState({
      acParameters,
      showACmenu
    });
  }

  render() {
    let persona = JSON.parse(localStorage.getItem("persona"));
    let cerrarNotificacion = JSON.parse(localStorage.getItem("cerrarNotificacion"))

    let nombreApellido = persona.nombre + " " + persona.apellido;
    let avatarInitials =
      this.state.avatar && this.state.avatar.initials
        ? this.state.avatar.initials
        : "";
    let avatarClassName =
      this.state.avatar && this.state.avatar.className
        ? this.state.avatar.className
        : "";
    let avatarStyle =
      this.state.avatar && this.state.avatar.backgroundImage
        ? {
            backgroundImage: "url(" + this.state.avatar.backgroundImage + ")",
          }
        : {};
    let showButton = this.state.showPlayStoreButton && this.state.codigo !== 0;

    // --- DEVOPS FIX: LOGOS DINÁMICOS Y FOOTER INTELIGENTE ---
    const showCopyright = ConfigBusiness.get("frontend.logos.copyright.visible") !== "false";
    const showPoweredBy = ConfigBusiness.get("frontend.logos.poweredBy.visible") !== "false";
    
    // Logo Menú Lateral: Queda fijo en la carpeta company para que siempre sea VEC Fleet (sin fallback onError por si falla la API)
    const logoMenuSrc = process.env.PUBLIC_URL + "/images/company/logo-company.png";
    
    // Logos Footer: Usan el branding si existe
    const logoFooterSrc = showCopyright ? this.getBrandedLogo("logo-copyright.png") : null;
    const logoPoweredSrc = showPoweredBy ? this.getBrandedLogo("logo-powered-by.png") : null;
    
    const versionLabel = process.env.REACT_APP_VERSION || "0.0.0";
    const usaInternaPolitica = ConfigBusiness.get('politicaDePrivacidad.usaInterna') === 'true';
    const privacyUrl = usaInternaPolitica ? '/politica-privacidad' : ConfigBusiness.get('frontend.politicaPrivacidad.url') || "#";
    const maintenanceAlertEnabled = ConfigBusiness.get("frontend.alertaMantenimiento.habilitado") === 'true';
    const maintenanceAlertMsg = ConfigBusiness.get("frontend.alertaMantenimiento.mensaje");

    return (
      <React.Fragment>
          {ConfigBusiness.get("generales.alertaSuspension")==='true' && (cerrarNotificacion===null || cerrarNotificacion===false) ?
              <Notificacion closeable={true} title={this.props.intl.formatMessage({id: 'layout.Alerta_de_suspension_por_falta_de_pago', defaultMessage: 'Alerta de suspensión por falta de pago'})} message={this.props.intl.formatMessage({id: 'layout.Tu_cuenta_tiene_un_pago_pendiente', defaultMessage: 'Tu cuenta tiene un pago pendiente. Por favor regularice la situación para poder seguir utilizando nuestro servicio sin interrupciones.'})} top="45%" />
          : null}

          {maintenanceAlertEnabled && (
              <Notificacion closeable={true} title={this.props.intl.formatMessage({ id: 'layout.Aviso_de_mantenimiento', defaultMessage: 'Aviso de Mantenimiento' })} message={maintenanceAlertMsg} top="5%" />
          )}

          {/* Header */}
          <nav className="header-navbar navbar-expand-md navbar navbar-with-menu navbar-without-dd-arrow fixed-top navbar-vec navbar-shadow">
            <div className="navbar-wrapper">
              <div className="navbar-header">
                <ul className="nav navbar-nav flex-row">
                  <li className="nav-item mobile-menu d-md-none mr-auto">
                    <a id="mobileMenuToggle" className="nav-link nav-menu-main menu-toggle hidden-xs">
                      <i className="ft-menu font-large-1"></i>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="navbar-brand" href="/">
                      <img className="brand-logo" alt="VEC" src={process.env.PUBLIC_URL + "/images/company/logo-app.png"} />
                      <h3 className="brand-text">
                        {!this.state.loadingLogoMenuLateral ? (
                            this.state.logoMenuLateralUrl ?
                                <img src={this.state.logoMenuLateralUrl} alt="" width="180" />
                              : (
                                  <img alt="Logo" src={logoMenuSrc} width="180" onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-company.png"; }} />
                              )
                          ) : null}
                      </h3>
                    </a>
                  </li>
                  <li className="nav-item d-md-none">
                    <a className="nav-link open-navbar-container" data-toggle="collapse" data-target="#navbar-mobile">
                      <i className="la la-ellipsis-v"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="navbar-container content">
                <div className="collapse navbar-collapse" id="navbar-mobile">
                  <ul className="nav navbar-nav mr-auto float-left">
                    <li className="nav-item d-none d-md-block"><a className="nav-link nav-menu-main menu-toggle hidden-xs"><i className="ft-menu"></i></a></li>
                    <li className="nav-item d-none d-md-block"><a className="nav-link nav-link-expand"><i className="ficon ft-maximize"></i></a></li>
                    {Security.hasPermission('ERIC_CHATBOT_CONSULTAR') ? <EricHeaderSearch /> : null}
                  </ul>
                  {ConfigBusiness.get("generales.alertaSuspension")==='true' ?
                    <ul className="nav navbar-nav mr-auto float-left">
                      <div className="d-flex align-items-start shadow-sm" style={{ backgroundColor: "white", borderLeft: "4px solid red", boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.2)", padding: "10px" }}>
                        <div className="d-flex align-items-center justify-content-center" style={{ width: "24px", height: "24px", borderRadius: "50%", backgroundColor: "white", color: "red", fontSize: "20px", fontWeight: "bold", textAlign: "center", padding: "10px", marginTop: "-2px" }}>
                          <i className="far fa-times-circle" style={{ color: "red" }}></i>
                        </div>
                          <h5><strong style={{color: "red"}}><FormattedMessage id="layout.Alerta_de_suspension_por_falta_de_pago" defaultMessage="Alerta de suspensión por falta de pago" /></strong></h5>
                      </div>
                    </ul>
                  : null}
                  <ul className="nav navbar-nav float-right">
                    <NotificationBell />
                    <li className="dropdown dropdown-user nav-item">
                      {this.state.showLogout ? (
                        <>
                          <a className="dropdown-toggle nav-link dropdown-user-link" data-toggle="dropdown">
                            <span className="mr-1"><span className="user-name text-bold-700">{nombreApellido}</span></span>
                            <span className="avatar avatar-online"><div ref="divAvatar" className={avatarClassName} style={avatarStyle}>{avatarInitials}</div></span>
                          </a>
                          <div className="dropdown-menu dropdown-menu-right">
                            <Link to="/cambiar-clave" className="dropdown-item"><i className="ft-lock"></i><FormattedMessage id="layout.dropdown_menu_right.select_cambiar_contrasenia" defaultMessage=" Cambiar contraseña" /></Link>
                            <div className="dropdown-divider"></div>
                            <a className="dropdown-item" onClick={Security.logout}><i className="ft-power"></i><FormattedMessage id="layout.dropdown_menu_right.cerrar_sesion" defaultMessage=" Cerrar Sesión" /></a>
                          </div>
                        </>
                      ) : (
                        <a className="dropdown-toggle nav-link dropdown-user-link">
                          <span className="mr-1"><span className="user-name text-bold-700">{nombreApellido}</span></span>
                          <span className="avatar avatar-online"><div ref="divAvatar" className={avatarClassName} style={avatarStyle}>{avatarInitials}</div></span>
                        </a>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </nav>

          {/* Menu */}
          <div className="main-menu menu-fixed menu-vec menu-accordion menu-shadow " data-scroll-to-active="true">
            <div className="main-menu-content">
              <ul className="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation" onClick={(e) => {
                if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
                const link = e.target.closest('a[href]');
                if (!link) return;
                if (link.target === '_blank') return;
                const href = link.getAttribute('href');
                this.actualizarMenuActivo(href);
                if (window.innerWidth < 992) {
                  document.body.classList.remove('menu-open');
                  document.body.classList.add('menu-hide');
                }
              }}>
                {Security.renderIfHasAnyPermission(["DASHBOARD_OPERATIVO2_VISUALIZAR", "DASHBOARD_COMERCIAL_VISUALIZAR"],
                  <li className="nav-item">
                    <a><i className="la la-bar-chart"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_dashboards.title" defaultMessage="Dashboards" /></span></a>
                    <ul className="menu-content">
                      {Security.renderIfHasAnyPermission("DASHBOARD_OPERATIVO2_VISUALIZAR", <li><Link to="/dashboardOperativo2"><FormattedMessage id="layout.menu_navigation.select_dashboards.operativo" defaultMessage="Operativo" /></Link></li> )}
                      {Security.renderIfHasAnyPermission("DASHBOARD_ANALITICO_VISUALIZAR", <li><Link to="/dashboardAnalitico"><FormattedMessage id="layout.menu_navigation.select_dashboards.operativo.analitico" defaultMessage="Analítico" /></Link></li> )}
                      {Security.renderIfHasAnyPermission("DASHBOARD_COMERCIAL_VISUALIZAR", <li className="menuItem"><Link to="/dashboardEconomico"><FormattedMessage id="layout.menu_navigation.select_dashboards.economico" defaultMessage="Económico" /></Link></li> )}
                    </ul>
                  </li>
                )}
                {Security.hasPermission('ERIC_CHATBOT_CONSULTAR') ? (
                  <li className="nav-item menuItem">
                    <Link to="/eric/chat">
                      <i className="la la-robot"></i>
                      <span className="menu-title" data-i18n="nav.dash.main">
                        <FormattedMessage id="eric.menu.titulo" defaultMessage="ERIC" />
                      </span>
                    </Link>
                  </li>
                ) : null}
                {(Security.hasAnyPermission(["BI_SUITE_1", "BI_SUITE_2", "BI_SUITE_3", "BI_SUITE_4", "BI_SUITE_5", "BI_SUITE_6", "BI_SUITE_7", "BI_SUITE_8", "BI_SUITE_9", "BI_SUITE_10", "BI_FILTRO_TRANSPORTADORA"]) && this.state.showBImenu) || (ConfigBusiness.get('menu.PowerBIEmbed.habilitado') === 'true' && Security.hasPermission("BI_FILTRO_TRANSPORTADORA")) ?
                  <li className="nav-item">
                    <a><i className="la la-magic"></i><span className="menu-title">BI Suite</span></a>
                    <ul className="menu-content">
                      {this.state.biParameters.map((bi, i) => {
                        const n = i + 1;
                        return Security.hasPermission(`BI_SUITE_${n}`) && bi.habilitado === 'true' && bi.url != '' && bi.nombre != '' ? <li key={i}><Link to={`/BI_${n}`}>{bi.nombre}</Link></li> : null;
                      })}
                      {ConfigBusiness.get('menu.PowerBIEmbed.habilitado') === 'true' && Security.hasPermission("BI_FILTRO_TRANSPORTADORA") ? <li><Link to="/power-bi-report">{ConfigBusiness.get('menu.PowerBIEmbed.display_name')}</Link></li> : null}
                    </ul>
                  </li>
                : ''}
                {Security.hasAnyPermission(["ASSET_CONTROL_1"]) && this.state.showACmenu ?
                  <li className="nav-item">
                    <a><i className="la la-magic"></i><span className=" menu-title">Asset Control</span></a>
                    <ul className="menu-content">
                      {this.state.acParameters.map((ac, i) => {
                        const n = i + 1;
                        return Security.hasPermission(`ASSET_CONTROL_${n}`) && ac.habilitado === 'true' && ac.url != '' && ac.nombre != '' ? <li key={i}><Link to={`/AC_${n}`}>{ac.nombre}</Link></li> : null;
                      })}
                    </ul>
                  </li>
                : ''}
                {Security.renderIfHasPermission("CALENDARIO_LISTAR", <li className="nav-item menuItem"><Link to="/calendarios"><i className="la la-calendar"></i><span className="menu-title"><FormattedMessage id="layout.menu_navigation.select_mantenimiento.calendario" defaultMessage="Calendario " /></span></Link></li> )}
                {Security.renderIfHasPermission("TICKETS_LISTAR", <li className="nav-item-collapser"><Link to="/tickets"><i className="las la-clipboard-list"></i><span className="menu-title"><FormattedMessage id="layout.menu_navigation.select_mantenimiento.tickets" defaultMessage="Tickets" /></span></Link></li> )}
                {Security.renderIfHasPermission("ROPS_LISTAR", <li className="nav-item-collapser"><Link to="/rop"><i className="las la-clipboard-list"></i><span className="menu-title"><FormattedMessage id="layout.menu_navigation.select_mantenimiento.rop" defaultMessage="Reportes Operador" /></span></Link></li> )}
                {Security.renderIfHasAnyPermission(["PANOL_PLANTILLAS_LISTAR", "PANOL_CONFIGURACION_LISTAR"],
                  <li className="nav-item menuItem panol2">
                    <a><i className="la la-clipboard"></i><span className="menu-title combustible" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_paniol2.title" defaultMessage="Pañol2" /></span></a>
                    {ConfigBusiness.get("panol.stock.habilitado") === "true" ? <ul className="menu-content"><li className="nav-item"><Link to="/panol2"><FormattedMessage id="layout.menu_navigation.select_paniol.stock" defaultMessage="Stock" /></Link></li></ul> : null}
                    <ul className="menu-content"><li className="nav-item"><Link to="/repuestos"><FormattedMessage id="layout.menu_navigation.select_paniol.items" defaultMessage="Items" /></Link></li></ul>
                    {Security.hasPermission('ITEMS_MARCAS_LISTAR') && ConfigBusiness.get('panol.marca.habilitado') === 'true' ? <ul className="menu-content"><li className="nav-item"><Link to="/insumos_marcas"><FormattedMessage id="layout.menu_navigation.select_paniol.insumos_marcas" defaultMessage="Marcas" /></Link></li></ul> : ''}
                    {Security.hasPermission('ITEMS_CLASIFICACIONES_LISTAR') && ConfigBusiness.get('panol.items.clasificacion.habilitado') === 'true' ? <ul className="menu-content"><li className="nav-item"><Link to="/item_clasificaciones"><FormattedMessage id="layout.menu_navigation.select_paniol.item_clasificaciones" defaultMessage="Clasificaciones" /></Link></li></ul> : ''}
                    {Security.hasPermission('ITEMS_CATEGORIAS_LISTAR') ? <ul className="menu-content"><li className="nav-item"><Link to="/item_categorias"><FormattedMessage id="layout.menu_navigation.select_paniol.item_categoria" defaultMessage="Categorías" /></Link></li></ul> : ''}
                  </li>
                )}

                {Security.renderIfHasAnyPermission(["TICKETS_LISTAR", "MANTENIMIENTOS_CORRECTIVOS_CREAR", "TICKETS_GESTORIA_CREAR", "PREVENTIVOS_LISTAR", "VENCIMIENTOS_LISTAR", "CALENDARIO_LISTAR"],
                  <li className="nav-item">
                    <a><i className="la la-wrench"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_mantenimiento.title" defaultMessage="Mantenimiento" /></span></a>
                    <ul className="menu-content">
                      {Security.renderIfHasPermission("MANTENIMIENTOS_CORRECTIVOS_CREAR", <li><Link to="/correctivos/add"><FormattedMessage id="layout.menu_navigation.select_mantenimiento.correctivos" defaultMessage="Correctivos" /></Link></li> )}
                      {Security.renderIfHasPermission("PREVENTIVOS_LISTAR", <li className="menuItem"><Link to="/preventivos"><FormattedMessage id="layout.menu_navigation.select_mantenimiento.preventivos" defaultMessage="Preventivos" /></Link></li> )}
                      {Security.renderIfHasPermission("VENCIMIENTOS_LISTAR", <li className="menuItem"><Link to="/vencimientos"><FormattedMessage id="layout.menu_navigation.select_mantenimiento.vencimientos" defaultMessage="Vencimientos" /></Link></li> )}
                      {Security.renderIfHasPermission("PLANES_MANTENIMIENTO_LISTAR", <li><Link to="/planmantenimientopreventivos"><FormattedMessage id="layout.menu_navigation.select_general.planes_mantenimiento" defaultMessage="Planes de Mantenimiento" /></Link></li> )}
                      {Security.renderIfHasPermission("SERVICIOS_LISTAR", <li><Link to="/servicios"><FormattedMessage id="layout.menu_navigation.select_general.servicios" defaultMessage="Servicios" /></Link></li> )}
                      {Security.renderIfHasPermission("TAREAS_LISTAR", <li><Link to="/tareas"><FormattedMessage id="layout.menu_navigation.select_general.tareas" defaultMessage="Tareas" /></Link></li> )}
                    </ul>
                  </li>
                )}

                {Security.renderIfHasAnyPermission(
                  ["COMBUSTIBLES_LISTAR", "COMBUSTIBLES_LOG_VISUALIZAR"],
                  <li className="nav-item menuItem">
                    <a><i className="la la-gas-pump"></i><span className="menu-title combustible" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_combustible.title" defaultMessage="Combustible" /></span></a>
                    <ul className="menu-content">
                      {Security.renderIfHasPermission("COMBUSTIBLES_LISTAR", <li><Link to="/combustibles"><FormattedMessage id="layout.menu_navigation.select_combustible.cargas" defaultMessage="Cargas" /></Link></li> )}
                      {Security.renderIfHasPermission("COMBUSTIBLES_LOG_VISUALIZAR", <li><Link to="/combustiblesLog"><FormattedMessage id="layout.menu_navigation.select_combustible.log_altas" defaultMessage="Log de Altas" /></Link></li> )}
                    </ul>
                  </li>
                )}
                {Security.renderIfHasAnyPermission(
                  ["CHECKLIST_LISTAR"],
                  ConfigBusiness.get("checklist").habilitado === "true" && (
                    <li className="nav-item">
                      <a><i className="la la-paste"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_checklist.title" defaultMessage="Checklist" /></span></a>
                      <ul className="menu-content">
                        {Security.renderIfHasPermission("CHECKLIST_LISTAR_HISTORICO", <li className="menuItem"><Link to="/formulario"><FormattedMessage id="layout.menu_navigation.select_checklist.historico" defaultMessage="Histórico" /></Link></li> )}
                        {Security.renderIfHasPermission("CHECKLIST_LISTAR_TIPO_FORMULARIOS", <li className="menuItem"><Link to="/tipoformulario"><FormattedMessage id="layout.menu_navigation.select_checklist.tipos_formularios" defaultMessage="Tipos de Formularios" /></Link></li> )}
                        {ConfigBusiness.get("checklist_recurrencia.habilitado")==='true' &&Security.renderIfHasPermission("FORMULARIO_RECURRENCIA_LISTAR", <li className="menuItem"><Link to="/formulario-recurrencias"><FormattedMessage id="layout.menu_navigation.select_checklist.config_recurrencia" defaultMessage="Conf. Recurrencia" /></Link></li> )}
                        {Security.renderIfHasPermission("ERIC_INSPECTOR_LISTAR", <li className="menuItem"><Link to="/eric/inspector">Eric IA</Link></li>)}
                      </ul>
                    </li>
                  )
                )}
                {ConfigBusiness.get("safefeedback.habilitado") === 'true' && (
                    <li className="nav-item">
                      <a><i className="las la-clipboard-list"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_safefeedback.title" defaultMessage="SafeFeedback" /></span></a>
                      {Security.renderIfHasPermission("SAFEFEEDBACK_LISTAR", <ul className="menu-content"><li className="menuItem"><Link to="/safefeedback-reportes"><FormattedMessage id="layout.menu_navigation.select_safefeedback.reportes" defaultMessage="Reportes" /></Link></li></ul> )}
                      {ConfigBusiness.get("safefeedback.activarNuevosComponentes") === 'true' && (
                        <>
                          <ul className="menu-content"><li className="menuItem"><Link to="/safefeedback-tipo-formularios"><FormattedMessage id="layout.menu_navigation.select_safefeedback.tipo_de_relatos" defaultMessage="Tipos de Relatos" /></Link></li></ul>
                          <ul className="menu-content"><li className="menuItem"><Link to="/safefeedback-formularios"><FormattedMessage id="layout.menu_navigation.select_safefeedback.relatos_test" defaultMessage="Relatos test" /></Link></li></ul>
                          {Security.renderIfHasPermission("SAFEFEEDBACK_RANKING_LISTAR", <ul className="menu-content"><li className="menuItem"><Link to="/safefeedback-ranking"><FormattedMessage id="layout.menu_navigation.select_safefeedback.ranking" defaultMessage="Ranking" /></Link></li></ul>)}
                        </>
                      )}
                      {ConfigBusiness.get("reportarIncidentes.habilitado") === "true" ? <ul className="menu-content"><li><Link to="/safefeedback-QR"><FormattedMessage id="layout.menu_navigation.select_safefeedback.QR" defaultMessage="QR" /></Link></li></ul> : ''}
                    </li>
                  )
                }
                {Security.renderIfHasAnyPermission(["INFRACCIONES_LISTAR"],
                  ConfigBusiness.get("infracciones").habilitado === "true" && (
                    <li className="nav-item menuItem">
                      <Link to="/moduloInfracciones">
                        <img src={process.env.PUBLIC_URL + "/images/infracciones/Infraciones-Menu.svg"} className="infracciones"></img>
                        <span className="menu-title combustible" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_infracciones.infracciones" defaultMessage="Infracciones" /></span>
                      </Link>
                    </li>
                  )
                )}


                {Security.renderIfHasAnyPermission(["MOVILES_LISTAR", "MARCAS_LISTAR", "MODELOS_LISTAR", "MODELO_TIPOS_LISTAR", "GPS_DEVICES_LIST"],
                  <li className="nav-item">
                    <a><i className="la la-car"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_moviles.title" defaultMessage="Móviles" /></span></a>
                    <ul className="menu-content">
                      {Security.renderIfHasPermission("MOVILES_LISTAR", <li><Link to="/moviles"><FormattedMessage id="layout.menu_navigation.select_moviles.moviles" defaultMessage="Móviles" /></Link></li> )}
                      {Security.renderIfHasPermission("MARCAS_LISTAR", <li className="menuItem"><Link to="/marcas"><FormattedMessage id="layout.menu_navigation.select_moviles.marcas" defaultMessage="Marcas" /></Link></li> )}
                      {Security.renderIfHasPermission("MOVILES_LISTAR", <li className="menuItem"><Link to="/clases"><FormattedMessage id="layout.menu_navigation.select_moviles.clases" defaultMessage="Clases" /></Link></li> )}
                      {Security.renderIfHasPermission("MODELOS_LISTAR", <li className="menuItem"><Link to="/modelos"><FormattedMessage id="layout.menu_navigation.select_moviles.modelos" defaultMessage="Modelos" /></Link></li> )}
                      {Security.renderIfHasPermission("MODELO_TIPOS_LISTAR", <li className="menuItem"><Link to="/modelotipos"><FormattedMessage id="layout.menu_navigation.select_moviles.tipos_modelo" defaultMessage="Tipos de Modelo" /></Link></li> )}
                      {Security.renderIfHasPermission("GPS_DEVICES_LIST", <li className="menuItem"><Link to="/gps/brands"><FormattedMessage id="layout.menu_navigation.select_moviles.dispositivos_GPS" defaultMessage="Dispositivos GPS" /></Link></li> )}
                    </ul>
                  </li>
                )}

                {Security.renderIfHasAnyPermission(
                  ["DISPONIBILIDAD_LISTAR", "DISPONIBILIDAD_REGLAS_LISTAR"],
                  <li className="nav-item">
                    <a><i className="la la-check-circle"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_disponibilidad.title" defaultMessage="Disponibilidad" /></span></a>
                    <ul className="menu-content">
                      {Security.renderIfHasPermission(
                        "DISPONIBILIDAD_LISTAR",
                        <>
                          <li><Link to="/disponibilidad"><FormattedMessage id="layout.menu_navigation.select_disponibilidad.disponibilidad" defaultMessage="Disponibilidad" /></Link></li>
                          {Security.hasPermission("MOVILES_RUTAS_IMPORT_AUDIT_LISTAR") && <li><Link to="/movilesRutasImportFiles"><FormattedMessage id="layout.menu_navigation.select_moviles_rutas.log_import_files" defaultMessage="Log de Importación" /></Link></li>}
                          {ConfigBusiness.get('ociosidad.habilitado') === 'true' && <li><Link to="/disponibilidad/bipeos"><FormattedMessage id="layout.menu_navigation.select_disponibilidad.bipeos" defaultMessage="Bipeos" /></Link></li>}
                        </>
                      )}
                      {Security.renderIfHasPermission(
                        "DISPONIBILIDAD_REGLAS_LISTAR",
                        <li><Link to="/disponibilidad/reglas"><FormattedMessage id="layout.menu_navigation.select_disponibilidad.reglas" defaultMessage="Reglas Rentadora" /></Link></li>
                      )}
                    </ul>
                  </li>
                )}

                {Security.renderIfHasAnyPermission(["LLANTAS_ASIGNACIONES_LISTAR", "LLANTAS_LISTAR", "LLANTAS_MODELOS_LISTAR", "LLANTAS_MARCAS_LISTAR", "LLANTAS_INSPECCIONES_LISTAR"],
                  ConfigBusiness.get("llantas").habilitado === "true" && (
                    <li className="nav-item">
                      <a>
                        <img src={process.env.PUBLIC_URL + "/images/llantas/llanta-layout.svg"} className="llanta"></img>
                        <span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_llantas.title" defaultMessage="Llantas" /></span>
                      </a>
                      <ul className="menu-content">
                        {Security.renderIfHasPermission("LLANTAS_LISTAR", <li><Link to="/llantas"><FormattedMessage id="layout.menu_navigation.select_llantas.llantas" defaultMessage="Llantas" /></Link></li> )}
                        {Security.renderIfHasPermission("LLANTAS_ASIGNACIONES_LISTAR", <li><Link to="/llantaasignaciones"><FormattedMessage id="layout.menu_navigation.select_llantas.llanta_asignaciones" defaultMessage="Asignaciones" /></Link></li> )}
                        {Security.renderIfHasPermission("LLANTAS_INSPECCIONES_LISTAR", <li><Link to="/llantainspecciones"><FormattedMessage id="layout.menu_navigation.select_llantas.llanta_inspecciones" defaultMessage="Inspecciones" /></Link></li> )}
                        {Security.renderIfHasPermission("LLANTAS_MARCAS_LISTAR", <li><Link to="/llantamarcas"><FormattedMessage id="layout.menu_navigation.select_llantas.marcas" defaultMessage="Marcas" /></Link></li> )}
                        {Security.renderIfHasPermission("LLANTAS_MODELOS_LISTAR", <li><Link to="/llantamodelos"><FormattedMessage id="layout.menu_navigation.select_llantas.modelos" defaultMessage="Modelos" /></Link></li> )}
                      </ul>
                    </li>
                  )
                )}

                {Security.renderIfHasAnyPermission(["GASTOS_LISTAR_HISTORICO", "GASTOS_TIPO_LISTAR"],
                    <li className="nav-item">
                      <a><i className="la la-money"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_gastos.title" defaultMessage="Gastos Extras" /></span></a>
                      <ul className="menu-content">
                        {Security.renderIfHasPermission("GASTOS_LISTAR_HISTORICO", <li className="menuItem"><Link to="/gastoExtra"><FormattedMessage id="layout.menu_navigation.select_gastos.historico" defaultMessage="Histórico" /></Link></li> )}
                        {Security.renderIfHasPermission("GASTOS_TIPO_LISTAR", <li className="menuItem"><Link to="/tipoGastoExtra"><FormattedMessage id="layout.menu_navigation.select_gastos.tipos_formularios" defaultMessage="Tipos de Gastos" /></Link></li> )}
                      </ul>
                    </li>
                  )}

                {Security.renderIfHasAnyPermission(
                  ["EQUIPAMIENTO_LISTAR", "EQUIPAMIENTO_TIPOS_LISTAR"],
                  <li className="nav-item">
                    <a><i className="la la-toolbox"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_equipamiento.title" defaultMessage="Equipamiento" /></span></a>
                    <ul className="menu-content">
                      {Security.renderIfHasPermission("EQUIPAMIENTO_LISTAR", <li className="menuItem"><Link to="/equipamiento"><FormattedMessage id="layout.menu_navigation.select_moviles.equipamiento" defaultMessage="Equipamiento" /></Link></li> )}
                      {Security.renderIfHasPermission("EQUIPAMIENTO_TIPOS_LISTAR", <li className="menuItem"><Link to="/tipoequipamiento"><FormattedMessage id="layout.menu_navigation.select_moviles.tipos_equipamiento" defaultMessage="Tipos de Equipamiento" /></Link></li> )}
                    </ul>
                  </li>
                )}

                {Security.renderIfHasPermission("PERSONAS_LISTAR", <li className="nav-item menuItem"><Link to="/personas"><i className="la la-user"></i><span className="menu-title"><FormattedMessage id="layout.menu_navigation.select_recursos.personas_label" defaultMessage="Personas" /></span></Link></li> )}
                {Security.renderIfHasPermission("GASTOS_EXTRA_ACCEDER", <li className="nav-item menuItem"><Link to="/gastosextra"><i class="las la-dollar-sign"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.gastos_extra.title" defaultMessage="Gastos Extra" /></span></Link></li> )}
                {Security.renderIfHasPermission("AVL_ACCEDER", <li className="nav-item menuItem"><Link to="/avl"><i className="la la-map-marker"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_AVL_mapa.title" defaultMessage="Mapa" /></span></Link></li> )}

                {Security.renderIfHasAnyPermission(
                  ["INFORMES_ACCEDER"],
                  <li className="nav-item menuItem">
                    <a><i className="la la-pie-chart"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_informes.title" defaultMessage="Informes" /></span></a>
                    <ul className="menu-content">
                      {Security.renderIfHasPermission("REPORTES_NO_REPORTAN", <li><Link to="/noreportan"><FormattedMessage id="layout.menu_navigation.select_informes.no_reportan" defaultMessage="No Reportan" /></Link></li> )}
                      {Security.renderIfHasPermission("REPORTES_ACTUALIZACION_KM", <li><Link to="/actualizacionkm"><FormattedMessage id="layout.menu_navigation.select_informes.actualizacion_Medidor" defaultMessage="Actualización Medidor" /></Link></li> )}
                      {Security.renderIfHasPermission("REPORTES_KM_MOVIL_LISTAR", <li><Link to="/kmMovil"><FormattedMessage id="layout.menu_navigation.select_informes.Medidor_por_movil" defaultMessage="Medidor por Móvil" /></Link></li> )}
                      {Security.renderIfHasPermission("REPORTES_MOVILES_INMOVILIZADOS", <li><Link to="/movilesInmovilizados"><FormattedMessage id="layout.menu_navigation.select_informes.moviles_inmovilizados" defaultMessage="Móviles Inmovilizados" /></Link></li> )}
                    </ul>
                  </li>
                )}

                {Security.renderIfHasAnyPermission(["OT_LISTAR", "TICKETS_GESTORIA_CREAR"],
                  <li className="nav-item">
                    <a><i className="la la-briefcase"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_gestoria.title" defaultMessage="Gestoría" /></span></a>
                    <ul className="menu-content">
                      {Security.renderIfHasPermission("TICKETS_GESTORIA_CREAR", <li><Link to="/ticketsgestoria/add"><FormattedMessage id="layout.menu_navigation.select_gestoria.tickets_gestoria" defaultMessage="Tickets de Gestoría" /></Link></li> )}
                      {Security.renderIfHasPermission("OT_LISTAR", <li className="nav-item-collapser"><Link to="/ordenestrabajo"><FormattedMessage id="layout.menu_navigation.select_gestoria.ordenes_de_trabajo" defaultMessage="Órdenes de Trabajo" /></Link></li> )}
                    </ul>
                  </li>
                )}
                {ConfigBusiness.get('periodoPresupuestario.habilitado') === 'true' && Security.renderIfHasAnyPermission(["PERIODO_PRESUPUESTARIO_REGIONES_VER", "PERIODO_PRESUPUESTARIO_SUBREGIONES_VER", "PERIODO_PRESUPUESTARIO_BASES_VER", "PERIODO_PRESUPUESTARIO_REGLAS_VER", "PERIODO_PRESUPUESTARIO_CONFIG_CONFIGURAR"],
                  <li className="nav-item menuItem">
                    <a><i className="la la-calculator"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_periodo_presupuestario.title" defaultMessage="P. Presupuestario" /></span></a>
                    <ul className="menu-content">
                      {Security.renderIfHasPermission("PERIODO_PRESUPUESTARIO_REGIONES_VER", <li><Link to="/periodoPresupuestario/regiones"><FormattedMessage id="layout.menu_navigation.select_regionalizacion.regiones" defaultMessage="Regiones" /></Link></li> )}
                      {Security.renderIfHasPermission("PERIODO_PRESUPUESTARIO_SUBREGIONES_VER", <li><Link to="/periodoPresupuestario/subregiones"><FormattedMessage id="layout.menu_navigation.select_regionalizacion.Subregiones" defaultMessage="Subregiones" /></Link></li> )}
                      {Security.renderIfHasPermission("PERIODO_PRESUPUESTARIO_BASES_VER", <li><Link to="/periodoPresupuestario/bases"><FormattedMessage id="layout.menu_navigation.select_recursos.bases" defaultMessage="Bases" /></Link></li> )}
                      {Security.renderIfHasPermission("PERIODO_PRESUPUESTARIO_REGLAS_VER", <li><Link to="/periodoPresupuestario/reglas"><FormattedMessage id="layout.menu_navigation.select_periodo_presupuestario.reglas" defaultMessage="Reglas" /></Link></li> )}
                      {Security.renderIfHasPermission('PERIODO_PRESUPUESTARIO_CONFIG_CONFIGURAR', <li><Link to="/configPeriodosPresupuestarios"><FormattedMessage id="Layout.config_periodos_prespuestarios" defaultMessage="Configuración de Períodos Presupuestarios" /></Link></li> )}
                    </ul>
                  </li>
                )}
                {Security.renderIfHasAnyPermission(["PERFILES_LISTAR", "FACTURAS_LISTAR", "CENTRO_COSTOS_LISTAR", "CENTRO_BENEFICIOS_LISTAR", "CATEGORIAS_LISTAR", "BASES_LISTAR", "GERENCIADORES_LISTAR", "TALLERES_LISTAR", "REGIONES_LISTAR", "SUBREGIONES_LISTAR", "REPORTAR_PROBLEMA"],
                  <li className="nav-item menuItem">
                    <a><i className="la la-cog"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_administracion.title" defaultMessage="Administracion" /></span></a>
                    <ul className="menu-content">
                      {Security.renderIfHasPermission("PERFILES_LISTAR", <li><Link to="/perfiles"><FormattedMessage id="layout.menu_navigation.select_seguridad.perfiles_permisos_seguridad" defaultMessage="Seguridad" /></Link></li> )}
                      {Security.renderIfHasPermission("FACTURAS_LISTAR", <li className="nav-item-collapser"><Link to="/facturas"><FormattedMessage id="layout.menu_navigation.select_facturacion.facturas" defaultMessage="Facturas" /></Link></li> )}
                      {Security.renderIfHasPermission("CENTRO_COSTOS_LISTAR", <li><Link to="/centrosCostos"><FormattedMessage id="layout.menu_navigation.select_divisiones.centros_costos" defaultMessage="Centros de Costos" /></Link></li> )}
                      {Security.renderIfHasPermission("TRANSPORTADORA_LISTAR", <li><Link to="/transportadoras"><FormattedMessage id="layout.menu_navigation.select_divisiones.transportadoras" defaultMessage="Transportadoras" /></Link></li> )}
                      {Security.renderIfHasPermission("CENTRO_BENEFICIOS_LISTAR", <li><Link to="/centrosBeneficios"><FormattedMessage id="layout.menu_navigation.select_divisiones.centros_beneficios" defaultMessage="Centros de Beneficios" /></Link></li> )}
                      {Security.renderIfHasPermission("CATEGORIAS_LISTAR", <li><Link to="/categorias"><FormattedMessage id="layout.menu_navigation.select_general.categorías" defaultMessage="Categorías" /></Link></li> )}
                      {Security.renderIfHasPermission("BASES_LISTAR", <li><Link to="/bases"><FormattedMessage id="layout.menu_navigation.select_recursos.bases" defaultMessage="Bases" /></Link></li> )}
                      {ConfigBusiness.get("sedeExterna.habilitado") === "true" && Security.renderIfHasPermission("SEDEEXTERNA_LISTAR", <li><Link to="/sedesExternas"><FormattedMessage id="layout.menu_navigation.select_recursos.sede_externa" defaultMessage="Sede Externa" /></Link></li> )}
                      {Security.renderIfHasPermission("RUTAS_LISTAR", <li><Link to="/rutas"><FormattedMessage id="Rutas" defaultMessage="Rutas" /></Link></li> )}
                      {Security.renderIfHasPermission("GERENCIADORES_LISTAR", <li><Link to="/gerenciadores"><FormattedMessage id="layout.menu_navigation.select_proveedores.gerenciadores" defaultMessage="Gerenciadores" /></Link></li> )}
                      {Security.renderIfHasPermission("TALLERES_LISTAR", <li><Link to="/talleres"><FormattedMessage id="layout.menu_navigation.select_proveedores.talleres" defaultMessage="Talleres" /></Link></li> )}
                      {Security.renderIfHasPermission("REGIONES_LISTAR", <li><Link to="/regiones"><FormattedMessage id="layout.menu_navigation.select_regionalizacion.regiones" defaultMessage="Regiones" /></Link></li> )}
                      {Security.renderIfHasPermission("SUBREGIONES_LISTAR", <li><Link to="/subRegiones"><FormattedMessage id="layout.menu_navigation.select_regionalizacion.Subregiones" defaultMessage="Subregiones" /></Link></li> )}
                      {Security.renderIfHasPermission("REPORTAR_PROBLEMA", <li><Link to="/osticket"><FormattedMessage id="layout.menu_navigation.select_reportar_problema.title" defaultMessage="Reportar Problema" /></Link></li> )}
                      {Security.renderIfHasPermission("MOTIVOS_LISTAR", <li><Link to="/motivos"><FormattedMessage id="Motivo" defaultMessage="Motivo" /></Link></li> )}
                      {Security.renderIfHasPermission("DIVISIONES_LISTAR", <li><Link to="/divisiones"><FormattedMessage id="Gestión_de_División" defaultMessage="Gestión de División" /></Link></li> )}
                      {Security.renderIfHasPermission("COMPANIAS_ORIGEN_LISTAR", <li><Link to="/companiasOrigen"><FormattedMessage id="Layout.Compania_de_Origen" defaultMessage="Compañía de Origen" /></Link></li> )}
                      {Security.isInternal() && Security.renderIfHasPermission("POLITICAS_PRIVACIDAD_LISTAR", <li><Link to="/politicasPrivacidad"><FormattedMessage id="politicasPrivacidad.menu" defaultMessage="Políticas de Privacidad" /></Link></li> )}
                    </ul>
                  </li>
                )}

                {Security.renderIfHasPermission(
                  "AYUDA_ACCEDER",
                  <li className="nav-item menuItem">
                    <a><i className="la la-support"></i><span className="menu-title" data-i18n="nav.dash.main"><FormattedMessage id="layout.menu_navigation.select_ayuda.title" defaultMessage="Ayuda" /></span></a>
                    <ul className="menu-content addHeight">
                      <li><a href="mailto:soporte@vecfleet.io" target="_blank"><FormattedMessage id="layout.menu_navigation.select_ayuda.soporte" defaultMessage="Soporte" /></a></li>
                    </ul>
                    <ul className="menu-content addHeight">
                      <li><a href="https://biblioteca.vecfleet.io/knowledge" target="_blank"><FormattedMessage id="layout.menu_navigation.select_ayuda.guia_usuario" defaultMessage="Guia de usuario" /></a></li>
                    </ul>
                  </li>
                )}
              </ul>
              {Security.renderIfHasPermission(
                "MOSTRAR_BOTON_GOOGLE_PLAY",
                ConfigBusiness.get("generales").mostrarBotonGooglePlay && showButton && (
                  <div className="google-play-button-div">
                    <a style={{ display: "flex", justifyContent: "center" }} className="google-play-button-a" href="https://play.google.com/store/apps/details?id=org.vecfleet.io">
                      <img style={{ width: "50%" }} className="google-play-button-img" alt="Disponible en Google Play" src="https://play.google.com/intl/en_us/badges/images/generic/es_badge_web_generic.png" />
                    </a>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <p style={{ fontSize: "0.90rem" }} className="google-play-button-p">
                        <FormattedMessage id="layout.google_play_button_p.ingresa_con_tu_usuario_y_contrasenia" defaultMessage="Ingresa con tu usuario y contraseña y el codigo " />{this.state.codigo}
                      </p>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>

          {usaInternaPolitica && this.state.politicaPendiente &&
            <PoliticaPrivacidadModal
              politica={this.state.politicaPendiente}
              onAceptado={() => this.setState({ politicaPendiente: null })}
            />
          }

          {/* Content */}
          <div className="app-content content">
            <Switch>
              {Security.hasPermission("DASHBOARD_OPERATIVO2_VISUALIZAR") && ConfigBusiness.get("frontend.redirectToWelcomeScreen") === "false" ? ( <Route exact path="/" component={DashboardOperativo2} /> ) : ( <Route exact path="/" component={Bienvenido} /> )}
              <Route path="/error" component={Error} />
              <Route path="/biUrlError" render={(props) => <Error {...props} biError/>}/>
              <Route path="/cambiar-clave" component={ChangePassword} />
              <Route path="/dashboardOperativo" component={DashboardOperativo} />
              <Route path="/dashboardOperativo2" component={DashboardOperativo2} />
              <Route path="/dashboardAnalitico" component={DashboardAnalitico} />
              <Route path="/dashboardEconomico" component={DashboardEconomico} />
              <Route path="/perfiles" component={Perfiles} />
              <Route path="/personas" component={Personas} />
              <Route path="/moviles" component={Moviles} />
              <Route path="/clases" component={Clases} />
              <Route path="/llantas" component={Llantas} />
              <Route path="/llantamarcas" component={LlantaMarcas} />
              <Route path="/llantamodelos" component={LlantasModelos} />
              <Route path="/llantaasignaciones" component={LlantaAsignaciones} />
              <Route path="/llantainspecciones" component={LlantaInspecciones} />
              <Route path="/bases" component={Bases} />
              <Route path="/usuariosmoviles" component={UsuariosMoviles} />
              <Route path="/avl" component={Avl} />
              <Route path="/gerenciadores" component={Gerenciadores} />
              <Route path="/sedesExternas" component={SedeExterna} />
              <Route path="/rutas" component={Rutas} />
              <Route path="/correctivos" component={Correctivos} />
              <Route path="/ticketsGestoria" component={TicketsGestoria} />
              <Route path="/tickets" component={Tickets} />
              <Route path="/osticket" component={Osticket} />
              <Route path="/talleres" component={Talleres} />
              <Route path="/calendarios" component={Calendarios} />
              <Route path="/power-bi-report" component={PowerBIReport} />
              <Route path="/regiones" component={Regiones} />
              <Route path="/subRegiones" component={SubRegiones} />
              <Route path="/marcas" component={Marcas} />
              <Route path="/modelos" component={Modelos} />
              <Route path="/modelotipos" component={ModeloTipos} />
              <Route path="/gps/brands" component={GPSDevices} />
              <Route path="/centroscostos" component={CentrosCostos} />
              <Route path="/transportadoras" component={Transportadoras} />
              <Route path="/centrosbeneficios" component={CentrosBeneficios} />
              <Route path="/vencimientos" component={Vencimientos} />
              <Route path="/servicios" component={Servicios} />
              <Route path="/tareas" component={Tareas} />
              <Route path="/planmantenimientopreventivos" component={PlanMantenimientoPreventivos} />
              <Route path="/preventivos" component={Preventivos} />
              <Route path="/noreportan" component={NoReportan} />
              <Route path="/actualizacionkm" component={ActualizacionKm} />
              <Route path="/facturas" component={Facturas} />
              <Route path="/categorias" component={Categorias} />
              <Route path="/videos" component={Videos} />
              {Security.isInternal() ? <Route path="/api-docs" component={SwaggerDocs} /> : null}
              {/* PAM-610: /eric/{módulo} es la convención para módulos ERIC (chat, inspector,
                  y los que vengan: Coordinator, Analyst, Auditor-Compliance, Discoveries...).
                  /eric a secas redirige a chat, ver el Redirect exact debajo. */}
              <Redirect exact from="/eric" to="/eric/chat" />
              {Security.hasPermission('ERIC_CHATBOT_CONSULTAR') ? <Route path="/eric/chat" component={Eric} /> : null}
              <Route path="/combustibles" component={Combustibles} />
              <Route path="/combustiblesLog" component={CombustiblesLogGrid} />
              <Route path="/KmMovil" component={KmMovil} />
              <Route path="/ordenestrabajo" component={OTs} />
              <Route path="/movilesInmovilizados" component={MovilesInmovilizados} />
              <Route path="/moduloInfracciones" component={Infracciones} />
              <Route path="/panol" component={Panol} />
              <Route path="/panol2" component={Panol2} />
              <Route path="/repuestos" component={Repuestos} />
              <Route path="/insumos_marcas" component={InsumosMarcas} />
              <Route path="/item_clasificaciones" component={ItemClasificaciones} />
              <Route path="/item_categorias" component={ItemCategoria} />
              <Route path="/tipoEquipamiento" component={TipoEquipamiento} />
              <Route path="/equipamiento" component={Equipamiento} />
              <Route path="/tipoFormulario" component={TipoFormulario} />
              <Route path="/formulario" component={Formulario} />
              <Route path="/formulario-recurrencias" component={FormularioRecurrencia} />
              <Route path="/safefeedback-reportes" component={SafeFeedbackReportes} />
              <Route path="/safefeedback-tipo-formularios" component={SafeFeedbackTipoFormulario} />
              <Route path="/safefeedback-formularios" component={SafeFeedbackFormulario} />
              <Route path="/safefeedback-ranking" component={SafeFeedbackRanking} />
              <Route path="/safefeedback-QR" component={SafeFeedbackQR} />
              <Route path="/rop" component={Rop} />
              <Route path="/gastoExtra" component={GastoExtra} />
              <Route path="/tipogastoExtra" component={TipoGastoExtra} />
              <Route path="/motivos" component={Motivos} />
              <Route path="/divisiones" component={Divisiones} />
              {Security.isInternal() ? <Route path="/politicasPrivacidad" component={PoliticasPrivacidad} /> : null}
              {Security.isLocalDevEnvironment() && Security.isInternal() ? <Route path="/monolog" component={Monolog} /> : null}
              {PERMISSION_PATH.map(per => {
                // NOTE: se agrega una key unica para eliminar el warning de react lanzado por consola: "Each child in a list should have a unique 'key' prop"
                return <Route key={`bi-${per.path}`} path={`${per.path}`} component={BISuite} />
              })}
              {ASSET_CONTROL_PERMISSION_PATH.map(per => {
                return <Route key={`asset-${per.path}`} path={`${per.path}`} component={AssetControl} />
              })}
              <Route path="/companiasOrigen" component={CompaniasOrigen}/>
              <Route path="/disponibilidad/reglas" component={DisponibilidadReglas} />
              <Route path="/disponibilidad/bipeos" component={BipeosGrid} />
              <Route path="/disponibilidad" component={Disponibilidad} />
              <Route path="/configPeriodosPresupuestarios" component={ConfigPeriodosPresupuestarios} />
              <Route path="/periodoPresupuestario" component={PeriodoPresupuestario} />
              <Route path="/movilesRutasImportFiles" component={MovilesRutasImportFilesGrid} />
              <Route path="/eric/inspector" component={EricContainer} />
              <Route path="/*" component={NotFound} />
              <Route path="/llantaodometrogrid" component={LlantaOdometroGrid} />
            </Switch>
          </div>

          {/* --- DEVOPS FIX: FOOTER INTELIGENTE --- */}
          <footer className="footer footer-static footer-light navbar-border navbar-shadow">
            <p className="clearfix blue-grey lighten-2 text-sm-center mb-0 px-2">
              {!showCopyright && !showPoweredBy ? (
                  <span className="d-block text-center">
                    <a href={privacyUrl} target="_blank" rel="noopener noreferrer" className="text-muted" style={{textDecoration: 'none'}}>
                      v{versionLabel}
                    </a>
                  </span>
              ) : (
                  <React.Fragment>
                      <span className="float-md-left d-block d-md-inline-block">
                        {showCopyright && (
                            <React.Fragment>
                                <FormattedMessage id="layout.navbar_footer.copyright " defaultMessage="Copyright " />
                                &copy; 2018–{new Date().getFullYear()}{" "}
                                {logoFooterSrc && (
                                    <img className="logo-footer-ga mx-1" alt="Company" src={logoFooterSrc} style={{ maxHeight: '45px', maxWidth: '200px', objectFit: 'contain' }} onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-copyright.png"; }} />
                                )}
                                <FormattedMessage id="layout.navbar_footer.todos_los_derechos_reservados" defaultMessage=" Todos los derechos reservados. " />
                            </React.Fragment>
                        )}
                        v{versionLabel}
                        {" | "}                        
                        <a href={privacyUrl}>
                            {this.props.intl.formatMessage({ id: 'frontend.footer.politicaPrivacidad', defaultMessage: 'Política de Privacidad' })}
                        </a>
                      </span>
                      <span className="float-md-right d-block d-md-inline-blockd-none d-lg-block">
                        {showPoweredBy && logoPoweredSrc && (
                            <React.Fragment>
                                <FormattedMessage id="layout.navbar_footer.powered_by" defaultMessage="Powered by: " />
                                <img alt="Powered By" src={logoPoweredSrc} className="ml-1" style={{ maxHeight: '35px', maxWidth: '150px', objectFit: 'contain' }} onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-powered-by.png"; }} />
                            </React.Fragment>
                        )}
                      </span>
                  </React.Fragment>
              )}
            </p>
          </footer>
      </React.Fragment>
    );
  }
}

export default injectIntl(Layout);
